import React from "react";

export default function StatusChangeModal({ isOpen, onClose, onConfirm, status }) {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white p-6 rounded-lg shadow-lg w-96">
                <div className="flex flex-col items-center">
                    <div className="text-red-500 text-4xl">❓</div>
                    <p className="text-center text-lg font-medium mt-2">
                        Are you sure you want to change the product status to <span className="font-bold">{status}?</span>
                    </p>
                </div>
                <div className="flex justify-center gap-4 mt-4">
                    <button className="px-4 py-2 border border-red-500 text-red-500 rounded" onClick={onClose}>
                        Cancel
                    </button>
                    <button className="px-4 py-2 bg-red-500 text-white rounded" onClick={onConfirm}>
                        Yes
                    </button>
                </div>
            </div>
        </div>
    );
}
